import { UserTypeId } from '../helpers/constants';
import BorrowerDashboard from '../components/Dashboard/Borrower/BorrowerDashboard';
import InvestorDashboard from '../components/Dashboard/Investor/InvestorDashboard';
import ProviderDashboard from '../components/Dashboard/Provider/ProviderDashboard';
import { useSelector } from 'react-redux';
import { RootState } from '../states/reducers';
const DashboardPage = () => {
  const { auth } = useSelector((state: RootState) => state);
  const userTypeId = auth.authUser?.user.user_type_id;

  const Dashboard = userTypeId === UserTypeId.INVESTOR ? InvestorDashboard : userTypeId === UserTypeId.SERVICE_PROVIDER ? ProviderDashboard : BorrowerDashboard;

  return <Dashboard />;
};

export default DashboardPage;
